// Api.
import api from './Base';
import LoginsDataTable from "../types/LoginsDataTable";
import { showError } from '../utils/showAlert';


const LoginApi = {

    getTags: async (signal?: AbortSignal): Promise<any[]> => {
        let url = `login/tag`;
        let tags: any[] = [];
        try {
            const response = await api.get<any[]>(url, { signal });
            if (response?.data) tags = response.data;
        } catch (error: any) {
            if (error?.name === 'AbortError' || error?.code === 'ERR_CANCELED') return tags;
            console.error('Failed to retrieve tags.', error);
            showError('Failed to retrieve tags', error.message || error.toString());
        }
        return tags;
    },

    getLogins:async (id?: number) => {

        let url = `login`;
        if (id) {
            url += `?id=${id}`
        }

        let logins: LoginsDataTable[] = [];

        await api.get<LoginsDataTable[]>(url)
            .then((response) => {
                logins = response.data;
            })
            .catch((error: any) => {
                console.error('Failed to retrieve logins.', error);
                showError('Failed to retrieve logins', error.message || error.toString());
            });
        return logins;
    }
}

export default LoginApi;